import { render, staticRenderFns } from "./inspection-record.vue?vue&type=template&id=23599764&scoped=true&"
import script from "./inspection-record.vue?vue&type=script&lang=js&"
export * from "./inspection-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23599764",
  null
  
)

export default component.exports